module.exports = __webpack_public_path__ + "static/media/inland.8a4f9594.svg";